
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import 'react';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var TabsContent = function TabsContent(_ref) {
  var index = _ref.index,
    content = _ref.content,
    isVisible = _ref.isVisible,
    style = _ref.style;
  return isVisible ? jsx("div", {
    id: "content-".concat(index),
    role: "tabpanel",
    style: style,
    "aria-hidden": !isVisible
  }, content) : null;
};

export { TabsContent as default };
//# sourceMappingURL=TabsContent.js.map
